import React, { Component } from 'react';


export default class Formular extends Component {
  state = {
    Vollername: '',
    Betreff: '',
    EMail: '',
    Nachricht: '',
  }



  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { Vollername, EMail, Betreff, Nachricht, sendTo } = this.state;

    // axios.post(`https://formspree.io/${sendTo}`, { Vollername, EMail, Betreff, Nachricht })
    //       .then((result) => {
    //         console.log(result);
    //       });
  }

  render() {
    return(
      <div className="container column col-6">
        <div className="container card-max-height">
          <form action={`https://formspree.io/${this.props.sendTo}`} method="POST">
            <input type="text" name="Vollername" value={this.state.Vollername} onChange={this.onChange} placeholder="Name"/>
            <input type="text" name="EMail" value={this.state.EMail} onChange={this.onChange} placeholder="E-Mail"/>
            <input type="text" name="Betreff" value={this.state.Betreff} onChange={this.onChange} placeholder="Betreff"/>
            <textarea type="text" name="Nachricht" value={this.state.Nachricht} onChange={this.onChange} className="nom" placeholder="Nachricht"/>
            <button className="btn" type="submit">Senden</button>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reusable/formular.js